import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=144c1c78&"
import script from "./AddContactDialog.vue?vue&type=script&lang=js&"
export * from "./AddContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddContactDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports